module.exports = __webpack_public_path__ + "static/img/walkway-ramp_256.e7e7345.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/walkway-ramp_256.png
// module id = 3Q3r
// module chunks = 0